export default __webpack_public_path__ + "static/media/yx1-on-table.b8596312.png";